import request from '@/utils/request';
import Base from '@/api/base.ts';

export default class OrgMgr extends Base {
  // 获取机构树
  public static getOrgTree() {
    return request.get(`/api/organ/tree`);
  }
  // 新建机构
  public static addOrg(params: object) {
    return request.post(`/api/organ`, params);
  }
  // 编辑机构
  public static editOrg(params: object) {
    return request.put(`/api/organ`, params);
  }
  // 删除机构
  public static deleteOrg(id: string) {
    return request.delete(`/api/organ/${id}`);
  }
}
